import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db as firestoreDb } from "@/src/lib/firebase";
import { Loader2 } from "lucide-react";

export function ShortUrlRedirect() {
  const { shortId } = useParams<{ shortId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const resolveUrl = async () => {
      if (!shortId) {
        navigate("/");
        return;
      }

      try {
        const docRef = doc(firestoreDb, "short_urls", shortId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          // We use window.location.href for external or internal full URLs
          // If it's internal, we could use navigate, but originalUrl is a full URL
          const originalUrl = data.originalUrl;
          
          if (originalUrl.startsWith(window.location.origin)) {
            // Internal link
            const path = originalUrl.replace(window.location.origin, "");
            navigate(path);
          } else {
            // External link (though we mostly expect internal)
            window.location.href = originalUrl;
          }
        } else {
          console.error("Short URL not found");
          navigate("/");
        }
      } catch (error) {
        console.error("Error resolving short URL:", error);
        navigate("/");
      }
    };

    resolveUrl();
  }, [shortId, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <Loader2 className="h-12 w-12 animate-spin text-primary" />
      <p className="text-muted-foreground font-medium animate-pulse">Redireccionando...</p>
    </div>
  );
}
